/**
 * ADV-259 — plain string mirrors of MessageSchemes.PageType/ModuleSurface/RequestPurpose
 * (`libs/packages/message-schemes/src/schema/WebEventTaxonomy.ts`). Deliberately NOT importing
 * the npm package here: it unconditionally pulls in `reflect-metadata` + `class-validator` for
 * its decorated schema classes, which is backend-only weight with no reason to ship in the FE
 * bundle just to read three enums. Values MUST stay in sync with the shared package by hand.
 */
export const PAGE_TYPE = {
    HOMEPAGE: 'HOMEPAGE',
    LANDING_PAGE: 'LANDING_PAGE',
    SEARCH_RESULT_LIST: 'SEARCH_RESULT_LIST',
    VEHICLE_DETAIL_PAGE: 'VEHICLE_DETAIL_PAGE',
    OTHER: 'OTHER',
};
export const MODULE_SURFACE = {
    SRL: 'SRL',
    LP_RESULTS: 'LP_RESULTS',
    TOP_OFFERS: 'TOP_OFFERS',
    RECENTLY_VIEWED: 'RECENTLY_VIEWED',
    SIMILAR_CARS: 'SIMILAR_CARS',
    VDP_MAIN: 'VDP_MAIN',
    LEASING_TEASERS: 'LEASING_TEASERS',
};
export const REQUEST_PURPOSE = {
    VISIBLE_VEHICLE_IMPRESSIONS: 'VISIBLE_VEHICLE_IMPRESSIONS',
    COUNT_ONLY: 'COUNT_ONLY',
    FILTER_METADATA: 'FILTER_METADATA',
    RECOMMENDATION: 'RECOMMENDATION',
};
export const trackingQuery = (pageType, module, requestPurpose) => `&pageType=${pageType}&module=${module}&requestPurpose=${requestPurpose}`;
// ADV-261 — mirrors LeadFunnelEventName in
// user-actions-contact/src/modules/common/interfaces/LeadFunnelEventInterface.ts. Only the two
// client-originated stages are used here; the rest are server-only.
export const LEAD_FUNNEL_EVENT = {
    FORM_START: 'lead_form_start',
    SUBMIT_ATTEMPT: 'lead_form_submit_attempt',
};
